import React from 'react'
import * as helpers from '../lib/helpers'
import { LanguageConsumer } from '../lib/LanguageContext'
import './Severity.css'

const Severity = (props) => {

  let severity = props.normalize ? helpers.normalizeSeverity(props.classId, props.maxSeverity) : props.classId
  let color = helpers.generateErrorColor(severity)

  return(
   <LanguageConsumer>
    {({polyglot}) =>
      (<div className='severity'>
        <span className={`circle ${props.tooltip ? 'tooltip' : ''}`} data-tooltip={polyglot.t(`severityDescriptions.${severity}`)} style={{backgroundColor: color}}></span>
        {props.displayString ?
            <span>{polyglot.t(`severityDescriptions.${props.classId}`)}</span>
        :
            <span>{props.classId}</span>
        }
      </div>)}
  </LanguageConsumer>
  )

}

export default Severity



// WEBPACK FOOTER //
// ./src/components/Severity.js